/**
 *
 * Asynchronously loads the component for InstallationInstructions
 *
 */

import { lazyLoad } from 'utils/loadable';

export const AddCelebrationsDates = lazyLoad(
  () => import('./index'),
  module => module.AddCelebrationsDates,
);
